import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      item: item.href ? `https://ggqcmf.cn${item.href}` : undefined,
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
      <nav className="breadcrumb-nav py-3" aria-label="面包屑导航">
        <ol>
          {items.map((item, index) => {
            const isLast = index === items.length - 1;
            return (
              <li key={index}>
                {isLast ? (
                  <span className="text-sm text-foreground-500">{item.label}</span>
                ) : item.href ? (
                  <Link to={item.href} className="text-sm text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">
                    {item.label}
                  </Link>
                ) : (
                  <span className="text-sm text-foreground-400">{item.label}</span>
                )}
              </li>
            );
          })}
        </ol>
      </nav>
    </>
  );
}